import { render } from "./noDataView.vue?vue&type=template&id=1db24ee1&scoped=true&ts=true"
import script from "./noDataView.vue?vue&type=script&lang=ts"
export * from "./noDataView.vue?vue&type=script&lang=ts"

import "./noDataView.vue?vue&type=style&index=0&id=1db24ee1&scoped=true&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/miyo-prod/ftrc-prd/src/project/fotile-riskctl/code/frontend/mgr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1db24ee1"]])

export default __exports__